<template>
	<h1>This is mobile/touch app</h1>
</template>

<script setup lang="ts">

</script>

<style>

</style>
